/** Default Profico copilot (Luka) — IDs match TemporaryChatContext. */
export const DEFAULT_COPILOT = {
  label: 'Luka',
  value: '1a229306-e0ec-4878-b3b5-629e477bb008',
  icon: null,
  mode: 'agent',
};

export const DEFAULT_COPILOT_ID = DEFAULT_COPILOT.value;
export const DEFAULT_COPILOT_NAME = DEFAULT_COPILOT.label;
export const DEFAULT_COPILOT_ICON = DEFAULT_COPILOT.icon;

export function isDefaultCopilot(agent) {
  if (!agent) return false;
  const id = agent.value ?? agent.id ?? agent.agent_id;
  const name = (agent.label || agent.agent_name || '').toLowerCase().trim();
  return (
    String(id) === DEFAULT_COPILOT_ID ||
    String(id) === '6d1cd244-2e8e-4782-981d-24cae676f7c7' ||
    name === 'luka' ||
    name === 'ferdy'
  );
}

export function findDefaultCopilot(agents) {
  if (!agents?.length) return null;
  return (
    agents.find(a => isDefaultCopilot(a)) ||
    null
  );
}

/** Map an API agent to a select/context option; brand the default as Luka. */
export function toDefaultAwareAgentOption(agent) {
  if (!agent) return null;
  const value = agent.id ?? agent.agent_id ?? agent.value;
  if (isDefaultCopilot(agent) || String(value) === DEFAULT_COPILOT_ID) {
    return {
      label: DEFAULT_COPILOT_NAME,
      value: DEFAULT_COPILOT_ID,
      icon: agent.icon ?? DEFAULT_COPILOT_ICON,
      mode: 'agent',
    };
  }
  return {
    label: agent.agent_name || agent.label,
    value,
    icon: agent.icon ?? null,
    mode: agent.mode || 'agent',
  };
}
